import { HStack, Text } from '@chakra-ui/react';

import { RadioIcon } from '@/imports/ui/chakra/feather';

export const HappeningNowMessage: React.FC = () => {
  return (
    <HStack spacing="3">
      <RadioIcon boxSize="4" color="primary.500" />
      <Text>Happening Now</Text>
    </HStack>
  );
};
